<template>
  <div>
    <navigation adaption/>
    <div class="page face-authentication">
      <div class="background">
        <img class="back" src="./images/back.png" alt="" @click="goBack">
        <p class="title">身份验证</p>
      </div>
      <div class="authentication-step">
        <div class="steps">
          <div class="step-item">
            <i class="custom-icon phone"></i>
            <span>请竖直紧握手机</span>
          </div>

          <div class="step-item">
            <i class="custom-icon face"></i>
            <span>请勿遮挡脸部</span>
          </div>

          <div class="step-item">
            <i class="custom-icon light"></i>
            <span>请在光线良好的环境下做测试</span>
          </div>

          <div class="step-item">
            <i class="custom-icon portrait"></i>
            <span>请将人脸放在人像框内</span>
          </div>
        </div>
        <p class="protocol-container">点击「开始验证」按钮表示您已阅读并同意 <span  @click="routeFaceProtocol">《人脸识别服务用户授权书》</span></p>
        <nd-button class="start-authentication" @click="startAuth" :loading="livenessStatus==='INIT'" :disabled="livenessStatus==='INIT'">{{livenessStatus==='INIT'? '认证中':'开始验证'}}</nd-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex' 
import wx from 'weixin-webview-jssdk'
import qs from 'qs'


export default {
  name: 'face-authentication',

  description: '刷脸活体认证',

  customReadyNotify: true,

  computed: {
    ...mapState('user', ['userInfo'])
  },
  components: {
    detention: () => import('./components/detention.vue')
  },

  data () {
    return {
      query: this.$route.query,
      livenessStatus: '',
      sceneType: ''
    }
  },
  beforeDestroy () {
    clearTimeout(window.timer)
  },
  created () {
    if (this.query.biz_id) {
      this.verifyAuthResult()
    }
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('authentication', [
      'megviiFaceX',
      'megviiFaceResultX',
      'onlyPreApply'
    ]),
    routeFaceProtocol () {
      const origin = process.env.VUE_APP_PROURL
      window.location.href = `${origin}/protocol/public/face` 
    },
    goBack () {
      if (this.isApiH5) {
        this.$router.back()
        return
      }
      wx.miniProgram.navigateBack()
    },
    async startAuth () {
      const { process, step } = this.$route.query
      let returnUrl = `${window.location.origin}/authentication/face-mp`
      const params = {}
      if (process) {
        params.process = process
      }
      if (step) {
        params.step = step
      }
      
 
      if (params?.process || process?.step) {
        returnUrl = `${window.location.origin}/authentication/face-mp?${qs.stringify(params)}`
      }
      const assignParams = {
        returnUrl
      } 
      // 消息中心
      const sceneType = this.$storage.get('sceneType') 
      if (this.$route.query.sceneType === 'MESSAGE_CENTER') {
        assignParams.sceneType = sceneType
        assignParams.sceneNo = this.$storage.get('applySerialNo')
      } else {
        !this.query.biz_id && this.$storage.remove('sceneType') //  回来的时候会把参数全部清除
      }
      
      const { success, data } = await this.megviiFaceX({
        ...assignParams
      })
      if (success) {
        this.redirectMegvii(data)
      }
    },

    redirectMegvii (data) {
      const { token } = data
      window.location.href = `${window.location.origin}/faceid/lite/do?token=${token}`
    },

    // 验证结果
    async verifyAuthResult () {
      const { success, data } = await this.megviiFaceResultX({
        bizId: this.query.biz_id
      })
      if (success) {
        this.livenessStatus = data.livenessStatus

        if (data.livenessStatus === 'INIT') {
          clearTimeout(window.timer)
          window.timer = setTimeout(() => {
            this.verifyAuthResult()
          }, 3000)
          return
        }
        // 消息中心
        if (this.$storage.get('sceneType') === 'MESSAGE_CENTER') {
          if (data.livenessStatus === 'SUCCESS') {
            this.$storage.remove('sceneType') 
            this.$router.replace({
              path: this.$storage.get('returnUrl'),
              query: {
                recordNo: this.$storage.get('applySerialNo'),
                result: 'PASS'
              }
            })
            return 
          } else {
            this.$router.replace({
              path: '/authentication/face-mp',
              query: {
                verificationMode: 'FACE_ID',
                recordNo: this.$storage.get('applySerialNo'),
                sceneType: 'MESSAGE_CENTER'
              }
            })
            this.$message('认证失败，请重新认证')
            return
          }
        }
        
        
        if (data.isLiveness) {
          if (this.$route.query.step === 'onlyPreApply') {
            await this.onlyPreApply()
          }
          if (this.isApiH5) {
            this.$router.replace({ path: '/withdraw/preview', query: { result: 'PASS' } })
            return 
          }
          setTimeout(() => {
            wx.miniProgram.postMessage({ data: { eventType: this.$route.query.process || 'LIVENESS_SUCCESS' } })
            wx.miniProgram.navigateBack()
          }, 1000)
          clearTimeout(window.timer)
        } else {
          this.$message('认证失败，请重新认证')
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .face-authentication {
        height: 100vh;
        position: relative;
       
        .background {
            width: 100%;
            height: 697px;
            background-size: 100% 100%;
            background-image: url(./images/bg.png);
            position: absolute;
            top: 0;
            z-index: 0;
            .back {
                width: 50px;
                height: 50px;
                z-index: 1;
                margin-top: 87px;
                margin-left: 54px;
            }
            .title {
                width: 100%;
                margin-top: 62px;
                color: white;
                font-size: 74px;
                font-weight: 300;
                padding-left: 56px;
            }
        }

        .authentication-step {
            width: 660px;
            margin: 0 45px;
            padding-bottom: 50px;
            background-color: #FFF;
            border-radius: 38px;
            overflow: hidden;
            box-shadow: 0 2px 8px 0 rgba(233,233,233,1), 0 12px 16px 0 rgba(0, 0, 0, 0.05);
            position: relative;
            z-index: 1;
            top: 379px;
            .steps {
                padding: 0 70px;
                margin-top: 48px;
                .step-item {
                    line-height: 110px;
                    position: relative;

                    .custom-icon {
                        width: 50px;
                        height: 50px;
                        display: inline-block;
                        position: absolute;
                        left: 0;
                        top: 30px;
                        background-size: 100% 100%;
                        &.phone {
                            background-image: url(./images/icon_phone.png);
                        }
                        &.face {
                            background-image: url(./images/icon_face.png);
                        }
                        &.light {
                            background-image: url(./images/icon_light.png);
                        }
                        &.portrait {
                            background-image: url(./images/icon_portrait.png);
                        }
                    }

                    span {
                        margin-left: 80px;
                        font-family: 'PingFangSC-Regular';
                        font-weight: 400;
                        font-size: 28px;
                        color: #666;
                    }
                }
            }

            .start-authentication {
                width: 508px;
                margin: 0 auto;
            }
            .protocol-container {
              margin-top: 150px;
              padding: 30px;
              span {
                color:#8eb2d8
              }
            }
        }
    }
</style>
